import { FC, useEffect, useState } from 'react';
import { Avatar, Button, Divider, Dropdown } from 'antd';
import { TbSlash } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DropdownMenuPanel } from '@/shared';

interface HighlightColorDropdownProps {
    editor: any;
}

const HighlightColorDropdown: FC<HighlightColorDropdownProps> = ({ editor }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    const colors = {
        default: {
            backgroundColor: token.colorBgBase,
            borderColor: token.colorBorder,
        },
        grey: {
            backgroundColor: token.colorBgBase,
            borderColor: token.colorBorder,
        },
        volcano: {
            backgroundColor: token.volcano2,
            borderColor: token.volcano3,
        },
        magenta: {
            backgroundColor: token.magenta2,
            borderColor: token.magenta3,
        },
        orange: {
            backgroundColor: token.orange2,
            borderColor: token.orange3,
        },
        gold: {
            backgroundColor: token.gold2,
            borderColor: token.gold3,
        },
        green: {
            backgroundColor: token.green2,
            borderColor: token.green2,
        },
        cyan: {
            backgroundColor: token.cyan2,
            borderColor: token.cyan3,
        },
        blue: {
            backgroundColor: token.blue2,
            borderColor: token.blue3,
        },
        purple: {
            backgroundColor: token.purple2,
            borderColor: token.purple2,
        },
    };

    const items = Object.entries(colors);

    return (
        <Dropdown
            placement='bottomLeft'
            popupRender={() => (
                <DropdownMenuPanel
                    style={{
                        padding: 0,
                        border: `1px solid ${token.colorBorder}`,
                    }}
                >
                    {items?.map(([key, { backgroundColor, borderColor }], index: number) => {
                        return (
                            <>
                                <Button
                                    key={key}
                                    className={editor.isActive('highlight') ? 'is-active' : ''}
                                    icon={
                                        <Avatar
                                            size={16}
                                            icon={
                                                index === 0 && (
                                                    <TbSlash
                                                        size={'0.75rem'}
                                                        style={{ verticalAlign: '-0.125rem', color: token.red6 }}
                                                    />
                                                )
                                            }
                                            shape='square'
                                            style={{
                                                backgroundColor: backgroundColor,
                                                border: `1px solid ${borderColor}`,
                                            }}
                                        />
                                    }
                                    type='text'
                                    onClick={() => {
                                        if (index === 0) {
                                            editor.commands.unsetHighlight();
                                        } else {
                                            editor.commands.toggleHighlight({ color: backgroundColor });
                                        }
                                    }}
                                />
                                {index === 0 && <Divider type='vertical' />}
                            </>
                        );
                    })}
                </DropdownMenuPanel>
            )}
            trigger={['click']}
        >
            {/* <SmallTooltip title="Highlight Color..." placement="topLeft"> */}
            <Button
                className={editor.isActive('bold') ? 'is-active' : ''}
                icon={
                    <Avatar
                        size={16}
                        icon={<TbSlash style={{ color: token.red6 }} />}
                        shape='square'
                        style={{
                            backgroundColor: token.colorBgBase,
                            border: `1px solid ${token.colorBorder}`,
                        }}
                    />
                }
                type='text'
            />
            {/* </SmallTooltip> */}
        </Dropdown>
    );
};

export default HighlightColorDropdown;
